import parseStatisticsData from './parseStatisticsData';
import parseReviewsData from './parseReviewsData';
import parseReviewsMedia, { type ReviewMedia } from './parseReviewsMedia';
import parseGeneratedSummary from './parseGeneratedSummary';
import type { ProductReview } from '~~/shared/globalTypes/reviews';

const getProductReview = (productReviews: ProductReview[] | undefined, id: number) => (productReviews ?? []).find((x) => x.productId === id) ?? null;

/**
 * parses product array values whether reviews v2 product data or the current reviews data in product xapi
 */
export default function parseProductReviewsData(
  { product, productId }: { product?: Product; productId: ProductId },
  reviewVideoUploadEnabled: boolean = false,
) {
  const reviewData = getProductReview(product?.productReviews, parseInt(productId, 10)) || null;
  const { paginatedReviews, reviewStatistics: productReviewStatistics, generatedSummary: productGeneratedSummary } = reviewData ?? {};

  // parsed reviews data objects
  const reviews = parseReviewsData(paginatedReviews?.reviews ?? []);
  const totalResults = paginatedReviews?.total ?? 0;
  const reviewStatistics = parseStatisticsData(productReviewStatistics, totalResults);
  const generatedSummary = parseGeneratedSummary(productGeneratedSummary);
  const reviewsWithMedia: ReviewMedia = parseReviewsMedia(reviewData, reviewVideoUploadEnabled);

  return {
    reviews,
    totalResults,
    reviewStatistics,
    generatedSummary,
    reviewsWithPhotos: reviewsWithMedia,
  };
}
